// ANCHOR React
import { memo } from 'react';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Components
import { ImageBadge } from '@lyon/components/utils/ImageBadge';
import { BadgeColor } from '@lyon/components/utils/ImageBadge/styles';

// ANCHOR Constants
import { LABEL } from './constants';

export const LyonCourseCardPinned = memo(() => {
  const isPinned = CourseCardData.useSelector((state) => state.data?.isPinned);

  if (isPinned) {
    return (
      <ImageBadge color={BadgeColor.inverseDefault}>
        {LABEL}
      </ImageBadge>
    );
  }

  return null;
});
